import Image from 'next/image';
import React from 'react';
import FadeInAnimation from "../Common/FadeInAnimation";
import { useTranslations } from '../../locales/useTranslations';
import { BiRocket, BiGroup, BiTrophy } from 'react-icons/bi';

const KarriereWachseMitUns = () => {
    const { t } = useTranslations();

    const features = [
        {
            icon: <BiRocket />,
            title: t('career_feature_growth'),
            description: t('career_feature_growth_desc')
        },
        {
            icon: <BiGroup />,
            title: t('career_feature_team'),
            description: t('career_feature_team_desc')
        },
        {
            icon: <BiTrophy />,
            title: t('career_feature_success'),
            description: t('career_feature_success_desc')
        }
    ];

    return (
        <section className="karriere-grow-section">
            <div className="container">
                <div className="row align-items-center g-5">
                    {/* Bild links */}
                    <div className="col-lg-6 col-md-12">
                        <FadeInAnimation direction="left" delay={50}>
                            <div className="karriere-image-container">
                                <div className="karriere-image-wrapper">
                                    <Image
                                        src="/images/karriere/unteresTeam.webp"
                                        alt="simplify data - our team"
                                        width={600}
                                        height={450}
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            display: 'block'
                                        }}
                                    />
                                    {/* Badge liegt auf dem Bild (unten rechts) */}
                                    <div className="karriere-stats-badge">
                                        <span className="karriere-stats-number">4+</span>
                                        <span className="karriere-stats-label">{t('career_years_experience')}</span>
                                    </div>
                                </div>
                            </div>
                        </FadeInAnimation>
                    </div>

                    {/* Content rechts */}
                    <div className="col-lg-6 col-md-12">
                        <FadeInAnimation direction="right" delay={100}>
                            <div className="karriere-content">
                                <span className="karriere-badge">
                                    {t('career_badge')}
                                </span>
                                <h2 className="karriere-title">
                                    {t('career_growWithUs_title')}
                                </h2>
                                <p className="karriere-description">
                                    {t('career_growWithUs_description1')}
                                </p>
                                <p className="karriere-description">
                                    {t('career_growWithUs_description2')}
                                </p>

                                {/* Feature Cards */}
                                <div className="karriere-features">
                                    {features.map((feature, index) => (
                                        <div key={index} className="karriere-feature-item">
                                            <div className="karriere-feature-icon">
                                                {feature.icon}
                                            </div>
                                            <div className="karriere-feature-content">
                                                <h4>{feature.title}</h4>
                                                <p>{feature.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default KarriereWachseMitUns;
